export const GET_PALLETSMAT = "GET_PALLETSMAT";
export const GET_PALLETMAT_UPDATE = "GET_PALLETMAT_UPDATE";
export const COPY_PALLETMAT = "COPY_PALLETMAT";
export const SAVE_PALLETMAT4COST = "SAVE_PALLETMAT4COST";